import * as Types from './types';

import { createAction } from '../utils';

export const updateUserApplications = (applications: Types.UserApplication[]) =>
    createAction(Types.UPDATE_USER_APPLICATIONS, { applications });

export const updateUserNotices = (notices: Types.UserNoticeLean[]) => createAction(Types.UPDATE_USER_NOTICES, { notices });

export const updateUserNoticeCounts = (noticeCounts: Types.UserNoticeCounts) =>
    createAction(Types.UPDATE_USER_NOTICE_COUNTS, { noticeCounts });

export const updateUserNotice = (userNotice: Types.UserNotice) => createAction(Types.UPDATE_USER_NOTICE, { userNotice });

export const signUserNotice = (signedNotice: Types.SignUserNotice) => createAction(Types.SIGN_USER_NOTICE, { signedNotice });

export const updateUserExperiences = (experiences: Types.UserExperienceGridRecord[]) =>
    createAction(Types.UPDATE_USER_EXPERIENCES, { experiences });

export type UserActionReturns =
    | ReturnType<typeof updateUserApplications>
    | ReturnType<typeof updateUserNotices>
    | ReturnType<typeof updateUserExperiences>;
